(() => {
  const storageKey = 'aurore-box-choice-v1';
  const requestProperty = '_Aurore box request';
  const linkedProperty = '_Aurore box for';
  const caseHandles = new Set(['kutiya-za-bizhuta-capri', 'kutiya-za-bizhuta-905']);
  let busy = false;
  let pollTimer;
  const roots = Array.from(document.querySelectorAll('[data-aur-boxes]'));
  const readPending = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (value && value.expires > Date.now()) return value;
      sessionStorage.removeItem(storageKey);
    } catch (error) { return null; }
    return null;
  };
  const clearPending = () => {
    try { sessionStorage.removeItem(storageKey); } catch (error) { return; }
    document.querySelectorAll('[data-aur-box-request]').forEach((input) => input.remove());
  };
  const getCart = async (url) => {
    const response = await fetch(url + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  };
  const addBox = async (url, id, nonce) => {
    const item = {id:Number(id),quantity:1};
    if (nonce) item.properties = {[linkedProperty]:nonce};
    const response = await fetch(url + '.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[item]})});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error('Box unavailable');
    return result;
  };
  const showCart = async (cartUrl) => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      try {
        const response = await fetch(cartUrl.replace(/\/$/, '') + '/update.js', {
          method:'POST',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({updates:{},sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})
        });
        if (!response.ok) throw new Error('Cart unavailable');
        const result = await response.json();
        const sections = result.sections || {};
        if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error('Cart unavailable');
        drawer.classList.remove('is-empty');
        drawer.renderContents(result);
        drawer.open();
        return;
      } catch (error) { console.warn('Aurore cart drawer:', error.message); }
    }
    if (window.location.pathname.replace(/\/$/, '') === cartUrl.replace(/\/$/, '')) window.location.reload();
    else window.location.assign(cartUrl);
  };
  const finish = async (pending) => {
    clearPending();
    clearInterval(pollTimer);
    await showCart(pending.cartUrl);
  };
  const checkPending = async () => {
    const pending = readPending();
    if (!pending || busy) return;
    busy = true;
    try {
      const cart = await getCart(pending.cartUrl);
      if (cart.items.some((item) => item.properties && item.properties[linkedProperty] === pending.nonce)) {
        await finish(pending);
        return;
      }
      if (pending.phase === 'adding') {
        clearPending();
        return;
      }
      const parent = cart.items.find((item) => item.properties && item.properties[requestProperty] === pending.nonce);
      if (!parent) return;
      if (cart.items.some((item) => caseHandles.has(item.handle))) {
        await finish(pending);
        return;
      }
      pending.phase = 'adding';
      sessionStorage.setItem(storageKey, JSON.stringify(pending));
      try {
        await addBox(pending.addUrl, pending.variant, pending.nonce);
        await finish(pending);
      } catch (error) {
        const verified = await getCart(pending.cartUrl);
        if (verified.items.some((item) => item.properties && item.properties[linkedProperty] === pending.nonce)) await finish(pending);
        else {
          clearPending();
          roots.forEach((root) => { const message = root.querySelector('[data-aur-box-status]'); message.hidden = false; message.textContent = JSON.parse(root.querySelector('[data-aur-box-data]').textContent).labels.error; });
        }
      }
    } catch (error) { return; }
    finally { busy = false; }
  };
  const startChecking = () => {
    if (!readPending()) return;
    clearInterval(pollTimer);
    let attempts = 0;
    checkPending();
    pollTimer = setInterval(() => {
      if (++attempts > 15 || !readPending()) clearInterval(pollTimer);
      else checkPending();
    }, 1200);
  };
  document.addEventListener('click', (event) => {
    const submitter = event.target.closest('button[type="submit"],input[type="submit"]');
    if (submitter && submitter.form && submitter.form.querySelector('[data-aur-box-request]')) startChecking();
  });
  document.addEventListener('submit', (event) => { if (event.target.querySelector('[data-aur-box-request]')) startChecking(); });
  window.addEventListener('pageshow', startChecking);
  roots.forEach((root) => {
    const data = JSON.parse(root.querySelector('[data-aur-box-data]').textContent);
    const dialog = root.querySelector('dialog');
    const image = root.querySelector('[data-aur-box-image]');
    const colors = root.querySelector('[data-aur-box-colors]');
    const thumbs = root.querySelector('[data-aur-box-thumbs]');
    const together = root.querySelector('[data-aur-box-with-jewel]');
    const only = root.querySelector('[data-aur-box-only]');
    const error = root.querySelector('[data-aur-box-error]');
    let model;
    let variant;
    let opener;
    let previousOverflow;
    let submitting = false;
    const showImage = (entry) => { image.src = entry.src; image.alt = entry.alt || model.title; };
    const showGallery = (src) => {
      const fileName = (url) => new URL(url, window.location.href).pathname.split('/').pop();
      const prefix = fileName(src).replace(/-[A-Z]\d+\.webp$/i, '');
      let entries = model.images.filter((entry) => fileName(entry.src).startsWith(prefix + '-'));
      if (!entries.length) entries = [{src,alt:model.title}];
      showImage(entries[0]);
      thumbs.replaceChildren();
      entries.forEach((entry, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', entry.alt || model.title + ' ' + (index + 1));
        button.setAttribute('aria-pressed', String(index === 0));
        const thumbnail = document.createElement('img');
        thumbnail.src = entry.src.replace(/([?&])width=640/, '$1width=100');
        thumbnail.alt = '';
        thumbnail.width = 44;
        thumbnail.height = 44;
        button.append(thumbnail);
        button.addEventListener('click', () => { showImage(entry); Array.from(thumbs.children).forEach((item) => item.setAttribute('aria-pressed', String(item === button))); });
        thumbs.append(button);
      });
    };
    const choose = (choice) => {
      variant = choice;
      root.querySelector('[data-aur-box-color-name]').textContent = choice.title;
      root.querySelector('[data-aur-box-price]').textContent = choice.price;
      Array.from(colors.children).forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.variantId === String(choice.id))));
      together.disabled = only.disabled = !choice.available;
      showGallery(choice.image);
    };
    const selectModel = (id) => {
      model = data.products.find((product) => String(product.id) === String(id));
      variant = null;
      error.hidden = true;
      root.querySelectorAll('[data-aur-box-model]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.aurBoxModel === String(id))));
      root.querySelector('[data-aur-box-name]').textContent = model.title;
      root.querySelector('[data-aur-box-size]').textContent = model.size;
      root.querySelector('[data-aur-box-detail]').textContent = model.detail;
      root.querySelector('[data-aur-box-color-name]').textContent = data.labels.choose;
      root.querySelector('[data-aur-box-price]').textContent = model.variants[0].price;
      together.disabled = only.disabled = true;
      colors.replaceChildren();
      model.variants.forEach((choice) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.disabled = !choice.available;
        button.dataset.variantId = choice.id;
        button.setAttribute('aria-pressed','false');
        button.setAttribute('aria-label', choice.title + (choice.available ? '' : ' · ' + data.labels.sold_out));
        const photo = document.createElement('img');
        photo.src = choice.image.replace(/([?&])width=640/, '$1width=140');
        photo.width = photo.height = 52;
        photo.alt = '';
        const title = document.createElement('span');
        title.textContent = choice.title;
        button.append(photo,title);
        button.addEventListener('click', () => choose(choice));
        colors.append(button);
      });
      showGallery(model.image);
      if (model.variants.length === 1 && model.variants[0].available) choose(model.variants[0]);
    };
    root.querySelectorAll('[data-aur-box-open]').forEach((button) => button.addEventListener('click', () => {
      opener = button;
      selectModel(button.dataset.aurBoxOpen);
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }));
    root.querySelectorAll('[data-aur-box-model]').forEach((button) => button.addEventListener('click', () => selectModel(button.dataset.aurBoxModel)));
    root.querySelectorAll('[data-aur-box-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow || ''; if (opener) opener.focus(); });
    const selectedStatus = (pending) => {
      const form = document.getElementById(root.dataset.formId);
      if (form) {
        let input = form.querySelector('[data-aur-box-request]');
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[' + requestProperty + ']'; input.dataset.aurBoxRequest = ''; form.append(input); }
        input.value = pending.nonce;
      }
      const status = root.querySelector('[data-aur-box-status]');
      status.hidden = false;
      status.textContent = data.labels.selected + ' ' + pending.title + ' · ' + pending.price + ' ';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = data.labels.remove;
      remove.addEventListener('click', () => { clearPending(); status.hidden = true; });
      status.append(remove);
    };
    together.addEventListener('click', () => {
      if (!variant || submitting) return;
      const form = document.getElementById(root.dataset.formId);
      const submitter = form && form.querySelector('button[type="submit"],input[type="submit"]');
      if (!form || !submitter || submitter.disabled) { error.hidden = false; return; }
      const nonce = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
      const pending = {nonce,variant:variant.id,parent:root.dataset.parentId,cartUrl:root.dataset.cartUrl,addUrl:root.dataset.addUrl,expires:Date.now() + 1800000,phase:'waiting',title:model.title + ' · ' + variant.title,price:variant.price};
      try { sessionStorage.setItem(storageKey,JSON.stringify(pending)); } catch (failure) { error.hidden = false; return; }
      let input = form.querySelector('[data-aur-box-request]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[' + requestProperty + ']'; input.dataset.aurBoxRequest = ''; form.append(input); }
      input.value = nonce;
      selectedStatus(pending);
      dialog.close();
      submitter.click();
      startChecking();
    });
    only.addEventListener('click', async () => {
      if (!variant || submitting) return;
      submitting = true;
      together.disabled = only.disabled = true;
      error.hidden = true;
      const nonce = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
      try {
        try { await addBox(root.dataset.addUrl, variant.id, nonce); }
        catch (failure) { const cart = await getCart(root.dataset.cartUrl); if (!cart.items.some((item) => item.properties && item.properties[linkedProperty] === nonce)) throw failure; }
        clearPending();
        root.querySelector('.aur-boxes-teasers').hidden = true;
        const status = root.querySelector('[data-aur-box-status]');
        status.hidden = false;
        status.textContent = data.labels.added + ' ' + model.title + ' · ' + variant.title + ' · ' + variant.price;
        const cartLink = document.createElement('a');
        cartLink.href = root.dataset.cartUrl;
        cartLink.textContent = data.labels.view_cart;
        status.append(document.createTextNode(' '), cartLink);
        dialog.close();
        await showCart(root.dataset.cartUrl);
      } catch (failure) { error.hidden = false; together.disabled = only.disabled = false; }
      finally { submitting = false; }
    });
    const pending = readPending();
    if (pending && String(pending.parent) === root.dataset.parentId) selectedStatus(pending);
  });
  startChecking();
})();
